/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { api, mutatingPost, type ApiResult } from "./client";

/** One active provider, as the manual-run picker needs it. */
export type ProviderOption = {
  id: string;
  firstName: string | null;
  lastName: string | null;
  healthieId: string | null;
  licensedStates: string[];
};

export function searchProviders(q: string): Promise<ApiResult<ProviderOption[]>> {
  return api<ProviderOption[]>(`/v1/admin/providers?q=${encodeURIComponent(q)}`);
}

export function queueManualRun(input: {
  providerId: string;
  slotStartsAt: string;
  slotEndsAt: string;
}): Promise<ApiResult<{ eventId: string; status: string }>> {
  return api<{ eventId: string; status: string }>("/v1/agent-runs/manual", mutatingPost(input));
}
